import type { OysterIcon } from "@oysterhr/icons"
import type { CalloutVariation } from "./types"

export const START_BAR_BG_VARIATION: Record<CalloutVariation, string> = {
  error: "bg-error-base",
  info: "bg-info-base",
  success: "bg-success-base",
  warning: "bg-warning-base",
  primary: "bg-primary-base",
}

export const CONTAINER_BG_VARIATION: Record<CalloutVariation, string> = {
  error: "bg-white",
  info: "bg-white",
  success: "bg-white",
  warning: "bg-white",
  primary: "bg-gradient-neutral",
}

export const BORDER_VARIATION: Record<CalloutVariation, string> = {
  error: "border-error-base",
  info: "border-info-base",
  success: "border-success-base",
  warning: "border-warning-base",
  primary: "border-primary-base",
}

export const ICON_NAME_VARIATION: Record<CalloutVariation, OysterIcon> = {
  error: "WarningCircleFill",
  info: "InfoFill",
  success: "CheckCircleFill",
  warning: "WarningFill",
  primary: "InfoFill",
}

export const ICON_COLOUR_VARIATION: Record<CalloutVariation, string> = {
  error: "text-error-base",
  info: "text-info-base",
  success: "text-success-base",
  warning: "text-warning-base",
  primary: "text-primary-base",
}
